import { connect } from 'react-redux';
import { FILTER_TYPES } from '../../../../constants';
import FilterDetails from './FilterDetails';

const mapStateToProps = (state) => {
    const selectedStars = state.selectedStars || [];

    return {
        workSampleChecked: state.workSampleChecked,
        businessChecked: state.businessChecked,
        industryDropdownSelected: state.industryDropdownSelected,
        num: selectedStars[0],
        searchTerm: state.filters[FILTER_TYPES.text],
    };
};

export default connect(mapStateToProps)(FilterDetails);
